import { render } from "./NewModule.vue?vue&type=template&id=50684160&scoped=true"
import script from "./NewModule.vue?vue&type=script&lang=js"
export * from "./NewModule.vue?vue&type=script&lang=js"

import "./NewModule.vue?vue&type=style&index=0&id=50684160&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50684160"]])

export default __exports__